<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <!-- 수급업체 근무인원 -->
      <c-table
        ref="vendorUserTable"
        title="LBL0003052"
        tableId="vendorUserTable"
        :columns="grid.columns"
        :data="grid.data"
        :usePaging="false"
        :hideBottom="true"
        :columnSetting="false"
        selection="multiple"
        rowKey="vendorUserCd"
        @table-data-change="tableDataChange"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <!-- 추가 -->
            <c-btn v-if="editable && this.parentVendorCd" label="LBLADD" icon="add" @btnClicked="addrow" />
            <!-- 삭제 -->
            <c-btn v-if="editable && this.parentVendorCd" label="LBLREMOVE" icon="remove" @btnClicked="removerow" />
            <!-- 저장 -->
            <c-btn v-if="editable && this.parentVendorCd" label="LBLSAVE" icon="save" @btnClicked="saveVendorUser" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'vendor-user',
  props: {
    parentVendorCd: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedVendorCd: '',
      grid: {
        columns: [],
        data: [],
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  watch: {
    parentVendorCd() {
      if (this.parentVendorCd) {
        this.getVendorUserList({ vendorCd: this.parentVendorCd })
      } else {
        this.grid.data = [];
      }
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.cim.vendor.user.list.url;
      this.saveUrl = transactionConfig.mdm.cim.vendor.user.save.url;
      this.deleteUrl = transactionConfig.mdm.cim.vendor.user.delete.url;

      this.$comm.getComboItems('SEX_CD').then(sexFlag => {
        this.grid.columns = [
          {
            name: 'personName',
            field: 'personName',
            // 이름
            label: 'LBLNAME',
            align: 'center',
            sortable: false,
            style: 'width:100px',
            type: 'text',
            fix: true,
          },
          {
            name: 'birthDate',
            field: 'birthDate',
            // 생년월일
            label: 'LBL0003053',
            style: 'width:120px',
            type: 'date',
            align: 'center',
            sortable: false,
            fix: true,
          },
          {
            name: 'sexCd',
            field: 'sexCd',
            // 성별
            label: 'LBL0003054',
            align: 'center',
            style: 'width:65px',
            sortable: false,
            valueName: 'codeName',
            itemText: 'codeName',
            itemValue: 'code',
            type: 'select',
            comboItems: sexFlag,
            fix: true,
          },
          {
            name: 'jobName',
            field: 'jobName',
            // 직책
            label: 'LBLPOSITION',
            style: 'width:100px',
            type: 'text',
            align: 'center',
            sortable: false,
            fix: true,
          },
          // {
          //   name: 'dailyEmployFlag',
          //   field: 'dailyEmployFlag',
          //   label: '일용직여부',
          //   style: 'width:50px',
          //   type: 'check',
          //   'true': 'Y',
          //   'false': 'N',
          //   align: 'center',
          //   sortable: false,
          // },
          {
            name: 'employDate',
            field: 'employDate',
            // 근무기간
            label: 'LBL0003055',
            style: 'width:200px',
            align: 'center',
            type: 'date',
            range: true,
            sortable: false,
          },
          {
            name: 'educationFlag',
            field: 'educationFlag',
            // 안전교육이수여부
            label: 'LBL0003056',
            align: 'center',
            sortable: false,
            child: [
              {
                name: 'industrySafetyEdcationFlag',
                field: 'industrySafetyEdcationFlag',
                // 산업
                label: 'LBL0003057',
                style: 'width:55px',
                type: 'check',
                'true': 'Y',
                'false': 'N',
                align: 'center',
                sortable: false,
              },
              {
                name: 'constructionSafetyEdcationFlag',
                field: 'constructionSafetyEdcationFlag',
                // 건설
                label: 'LBL0003058',
                style: 'width:55px',
                type: 'check',
                'true': 'Y',
                'false': 'N',
                align: 'center',
                sortable: false,
              },
            ]
          },
          // {
          //   name: 'remarks',
          //   field: 'remarks',
          //   label: 'LBLREMARK',
          //   align: 'left',
          //   type: 'text',
          //   style: 'width:100px',
          //   sortable: false,
          // },
          {
            name: 'attach',
            field: 'attach',
            // 이수증 첨부파일
            label: 'LBL0003059',
            align: 'center',
            style: 'width:200px',
            type: 'attach',
            taskClassCd: 'VENDOR_USER_EDCATION',
            keyText: 'vendorUserCd',
            sortable: false,
          }
        ];
        if (this.parentVendorCd) {
          this.getVendorUserList({ vendorCd: this.parentVendorCd })
        }
      });
    },
    getVendorUserList(row) {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {vendorCd: row.vendorCd};
      this.$http.request((_result) => {
        if (_result.data && _result.data.length > 0) {
          this.$_.forEach(_result.data, item => {
            this.$set(item, 'employDate', [item.employStartDate, item.employEndDate])
          })
        }
        this.grid.data = _result.data;
      },);
    },
    tableDataChange(props, col) {
      if (col.name === 'employDate' && props.row[col.name] && props.row[col.name].length > 0) {
        this.$set(props.row, 'employStartDate', props.row[col.name][0])
        this.$set(props.row, 'employEndDate', props.row[col.name][1])
      } else {
        this.$set(props.row, 'employStartDate', '')
        this.$set(props.row, 'employEndDate', '')
      }
    },
    addrow() {
      // 초기에는 userId에 tempId를 부여
      this.grid.data.splice(0, 0, {
        editFlag: 'C',
        vendorCd: this.parentVendorCd,
        vendorUserCd: uid(),
        personName: '',
        birthDate: '',
        sexCd: null,
        jobName: '',
        dailyEmployFlag: 'N',
        employStartDate: '',
        employEndDate: '',
        employDate: [],
        industrySafetyEdcationFlag: 'N',
        constructionSafetyEdcationFlag: 'N',
        remarks: '',
      })
    },
    saveVendorUser() {
      if (this.$comm.validTable(this.grid.columns, this.grid.data)) {
        let saveData = this.grid.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$_.forEach(saveData, _item => {
                if (_item.employDate.length > 0) {
                  this.$set(_item, 'employStartDate', _item.employDate[0])
                  this.$set(_item, 'employEndDate', _item.employDate[1])
                }
              })
              this.$http.url = this.saveUrl;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                window.getApp.$emit('APP_REQUEST_SUCCESS');
                this.getVendorUserList({ vendorCd: this.parentVendorCd })
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: 'MSGNOCHANGEDATA', // 변경된 데이터가 없습니다.
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    removerow() {
      let selectData = this.$refs['vendorUserTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGREMOVE', // 삭제하시겠습니까?,
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.$format(this.deleteUrl);
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              // this.getVendorUserList({ vendorCd: this.parentVendorCd })
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$_.forEach(selectData, item => {
                this.grid.data = this.$_.reject(this.grid.data, item);
              })
              this.$refs['vendorUserTable'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>
